import { createSlice } from "@reduxjs/toolkit";
import leadManagementThunkActions from "./thunk/leadManagementThunk";
import extraReducers from "./thunk/leadManagementExtraReducers";

export const LEAD_MANAGEMENT_FLOW_SLICE_NAME = "leadManagement";

const initialState = {
  customerData: {
    data: [],
    error: null,
    isLoading: false,
  },
  categoryBrandData: {
    data: [],
    error: null,
    isLoading: false,
  },
  reasonData: {
    data: [],
    error: null,
    isLoading: false,
  },
  viewLeadsData: {
    data: [],
    error: null,
    isLoading: false,
    // Channel scope of the last fetched page (was `leadType`).
    channel: "",
  },
  downloadData: {
    data: [],
    error: null,
    isLoading: false,
  },
  downloadData: {
    data: [],
    error: null,
    isLoading: false,
  },
  createLeadData: {
    data: [],
    error: null,
    isLoading: false,
  },
  updateLeadData: {
    data: [],
    error: null,
    isLoading: false,
  },
  attributes: {
    data: [],
    error: null,
    isLoading: false,
  },
  status: {
    data: [],
    error: null,
    isLoading: false,
  },
};

export const leadManagementFlowSlice = createSlice({
  name: LEAD_MANAGEMENT_FLOW_SLICE_NAME,
  initialState,
  reducers: {
    resetReports: (state) => ({ ...state, reportListing: { data: [] } }),
  },
  extraReducers,
});

export const leadManagementActions = {
  ...leadManagementFlowSlice.actions,
  ...leadManagementThunkActions,
};

export default leadManagementFlowSlice.reducer;
